/**
 * Enhanced Leadership Team Data
 * Based on LinkedIn profiles with professional descriptions
 */

export const LEADERSHIP_TEAM = [
  {
    id: 'sanjay-jain',
    name: 'Sanjay Jain',
    title: 'Founder & Chief Executive Officer',
    linkedin: 'https://www.linkedin.com/in/saanjayjain/',
    image: '/assets/images/Team Members/Bootminds Employee images/Sanjay Jain.png',
    description: 'Bootminds founder and returning CEO. Prior leadership across IndiaStack/Aadhaar, UIDAI, the Gates Foundation, and Intelliswift’s global GCC practice. Sanjay now anchors GCC launch strategy, transparent pricing governance, and CXO stakeholder management for Bootminds engagements.',
    expertise: ['GCC Launch Strategy', 'Digital Public Infrastructure', 'Executive Governance', 'Fintech Innovation'],
    location: 'Bengaluru, India',
    segment: 'executive'
  },
  {
    id: 'swetha-jain',
    name: 'Swetha Jain',
    title: 'Chief Growth & Partnerships Officer',
    linkedin: 'https://www.linkedin.com/in/swetha-jain-dm/',
    image: '/assets/images/Team Members/Bootminds Employee images/Swetha Jain.png',
    description: 'Growth leader with nearly two decades in B2B demand generation and partnership development at Intelliswift, Collabera, and Boutiqaat. Swetha drives Bootminds’ Launch Blueprint pipeline, public-sector alliances, and SkillStack™ go-to-market programs.',
    expertise: ['Strategic Growth', 'Demand Generation', 'Partnership Design', 'Brand Positioning'],
    location: 'Bengaluru, India',
    segment: 'executive'
  },
  {
    id: 'prameela-mallaiah',
    name: 'Prameela Mallaiah',
    title: 'Managing Director, GCC Operations',
    linkedin: 'https://www.linkedin.com/in/prameela-mallaiah-a46b359/',
    image: '/assets/images/Team Members/Bootminds Employee images/Prameela.png',
    description: 'Operations executive with 20+ years delivering large-scale GCC and managed services programs at Intelliswift, Magneti Marelli, and 24/7 Customer. Prameela oversees milestone governance, vendor orchestration, and zero-risk transition programs across Bootminds launches.',
    expertise: ['GCC Operations', 'Program Governance', 'Vendor Management', 'Process Excellence'],
    location: 'Bengaluru, India',
    segment: 'executive'
  },
  {
    id: 'vandita-rai',
    name: 'Vandita Rai',
    title: 'Client Partner, Expansion & Success',
    linkedin: 'https://www.linkedin.com/in/vanditarai/',
    image: '/assets/images/Team Members/Bootminds Employee images/Vandita Rai.png',
    description: 'Client services specialist with enterprise account leadership at Accenture, Zensar, and Alight Solutions. Vandita manages CXO governance councils, government liaison workstreams, and steady-state success metrics for Bootminds expansion clients.',
    expertise: ['Client Partnering', 'Government Liaison', 'Change Management', 'Customer Success'],
    location: 'Mumbai, India',
    segment: 'operating'
  },
  {
    id: 'hitesh-m',
    name: 'Hitesh M',
    title: 'Director, Cloud & Security Architecture',
    linkedin: 'https://www.linkedin.com/in/hitesh-m-08456423b/',
    image: '/assets/images/Team Members/Bootminds Employee images/Hitesh.png',
    description: 'Cloud and infrastructure leader with prior stints at Intelliswift, Mindtree, and Hurix. Hitesh designs zero-trust blueprints, workplace technology stacks, and SecOps controls for new GCC launches.',
    expertise: ['Cloud Architecture', 'Zero-Trust Security', 'Hybrid Workplace', 'Enterprise Platforms'],
    location: 'Bengaluru, India',
    segment: 'operating'
  },
  {
    id: 'tuhina-sarkar',
    name: 'Tuhina Sarkar',
    title: 'Director, Talent & Culture',
    linkedin: 'https://www.linkedin.com/in/tuhina-sarkar-4a4a9218b/',
    image: '/assets/images/Team Members/Bootminds Employee images/Tuhina Sarkar.png',
    description: 'HR leader with talent acquisition and people-operations experience at Intelliswift, Artech, and ABC Consultants. Tuhina codifies the SkillStack™ candidate experience, leadership searches, and early-tenure retention analytics.',
    expertise: ['Leadership Hiring', 'People Experience', 'HR Operating Models', 'Org Development'],
    location: 'Delhi NCR, India',
    segment: 'operating'
  }
];

// Team statistics for visual representation
export const TEAM_STATS = {
  totalMembers: LEADERSHIP_TEAM.length,
  executiveTeam: LEADERSHIP_TEAM.filter(member => member.segment === 'executive').length,
  operatingLeaders: LEADERSHIP_TEAM.filter(member => member.segment === 'operating').length,
  advisoryPartners: LEADERSHIP_TEAM.filter(member => member.segment === 'advisory').length,
  globalLocations: [...new Set(LEADERSHIP_TEAM.map(member => member.location))].length
};

// Expertise areas across the team
export const TEAM_EXPERTISE_AREAS = [
  'Global Capability Centers',
  'Digital Transformation',
  'Strategic Leadership',
  'Technology Innovation',
  'Business Development',
  'Operational Excellence',
  'Client Relationships',
  'Talent Management'
];

export default LEADERSHIP_TEAM;